import validate from "/app/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.19.130_db0@0.3.4_ioredis@5.10.1_magicast@0.5.3_rollup@4.60.4_sass@1_tn2gqs4gx373jt2wpoo3hg7puq/node_modules/nuxt/dist/pages/runtime/validate.js";
import block_45route_45global from "/app/src/client/middleware/block-route.global.ts";
export const globalMiddleware = [
  validate,
  block_45route_45global
]
export const namedMiddleware = {}